define.alias("shared/components/shared/upgrade/bonus-features", "calendar/components/shared/upgrade/bonus-features");